import { render } from "./ArrayLayoutRenderer.vue?vue&type=template&id=72b1357c&scoped=true&ts=true"
import script from "./ArrayLayoutRenderer.vue?vue&type=script&lang=ts"
export * from "./ArrayLayoutRenderer.vue?vue&type=script&lang=ts"

import "./ArrayLayoutRenderer.vue?vue&type=style&index=0&id=72b1357c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72b1357c"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QTooltip});
